var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConjugal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 65 66.7",
    style: {
      enableBackground: "new 0 0 65 66.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9B0008;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.3,22.4c-0.3,0-0.5-0.1-0.7-0.2C29.4,15,29.7,8,30.4,5.3c0.8-3,3.2-5.2,5.8-5.3c2.3-0.2,4.5,0.7,6.1,2.4 c1.6-1.7,3.8-2.5,6.1-2.4l0,0c2.6,0.1,5,2.3,5.8,5.3c0.7,2.7,1,9.7-11.1,17C42.8,22.4,42.5,22.4,42.3,22.4z M36.5,2.9h-0.2 c-1.6,0.3-2.8,1.5-3.1,3.1c-0.4,1.6-0.9,7.1,9.1,13.3c10-6.3,9.5-11.7,9.1-13.3c-0.3-1.6-1.5-2.8-3.1-3.1l0,0 c-1.9-0.2-3.8,0.8-4.6,2.6c-0.3,0.8-1.1,1.2-1.8,0.9c-0.4-0.1-0.7-0.5-0.9-0.9C40.2,3.8,38.4,2.8,36.5,2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.9,12.6c-0.3,0-0.6-0.1-0.8-0.4c-1.5-2-2-3.9-1.5-5.6C35,5.3,36,4.4,37.3,4.1c0.5,0.1,0.9,0.6,0.9,1.1 c0,0.3-0.2,0.6-0.6,0.8c-0.6,0.1-1.1,0.6-1.3,1.1c-0.3,1.1,0.1,2.4,1.2,3.9c0.3,0.4,0.2,1-0.2,1.4C37.3,12.5,37.1,12.6,36.9,12.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.7,63C9.7,63,0,53.4-0.1,41.4s9.6-21.7,21.6-21.7c4,0,8,1.1,11.4,3.2c1,0.5,1.4,1.6,0.9,2.6 c-0.5,1-1.6,1.4-2.6,0.9c-0.1-0.1-0.2-0.1-0.3-0.2C22.6,21,11.7,23.6,6.5,32S4,51.3,12.4,56.5s19.3,2.5,24.5-5.8 c3.4-5.5,3.5-12.5,0.3-18.1c-0.5-0.9-0.2-2.1,0.7-2.6c0.9-0.5,2.1-0.2,2.6,0.7c5.9,10.4,2.3,23.6-8.1,29.6 C29.1,62,25.4,63,21.7,63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44,66.7c-1.9,0-3.8-0.3-5.6-0.8c-1-0.2-1.7-1.2-1.5-2.3c0.2-1,1.2-1.7,2.3-1.5c0.1,0,0.2,0,0.2,0.1 c9.1,2.5,18.6-2.8,21.1-12c2.5-9.1-2.8-18.6-12-21.1S30,31.9,27.4,41c-0.4,1.5-0.6,3-0.6,4.6c0,2.4,0.5,4.8,1.5,7 c0.5,1,0.1,2.1-0.9,2.6c-1,0.5-2.1,0.1-2.6-0.9c0,0,0-0.1,0-0.1c-1.2-2.7-1.8-5.6-1.8-8.6c0-11.6,9.4-21,21-21s21,9.4,21,21 S55.5,66.6,44,66.7L44,66.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConjugal);
export default __webpack_public_path__ + "static/media/conjugal.35f72b4dc4d93b34c672322226cdb080.svg";
export { ForwardRef as ReactComponent };